import axios from "axios";
import settings from "../../../../utils/settings";

const url = `${settings.accountsUrl}api/admin/agreement`;

export const deleteStaticPages = (id) => axios.delete(`${url}/${id}`);



// WEBPACK FOOTER //
// ./src/views/pages/static-pages/requests/deleteStaticPages.js